import { 
  SET_MENUS,
  SET_DISH,
  SET_MEALS_TO_CHANGE,
  SET_PROGRESS,
} from '../actions/menus';

let initialState = {
  menusData: [],
  dishDetails: null,
  mealsToChange: [],
  progressData: null,
};

const menus = (state = initialState, action) => {
  switch (action.type) {
    case SET_MENUS:
      return {
        ...state,
        menusData: [ ...action.payload ],
      };

    case SET_DISH:
      return {
        ...state,
        dishDetails: action.payload,
      };

    case SET_MEALS_TO_CHANGE:
      return {
        ...state,
        mealsToChange: action.payload,
      };

    case SET_PROGRESS:
      return {
        ...state,
        progressData: action.payload,
      };

    default:
      return state;
  }
};

export default menus;
